import { ActionPayloadDto, ActionRequestDto, NavigationTypeEnum } from "@app/core/dto/abstract-action.dto";
import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { UrlParser } from "@app/core/utils/url-parser/url-parser";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";

export class NavigationCommand implements ActionCommand {
  constructor(private renderEngineComponent: any) { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    if (actionData.navigationType === NavigationTypeEnum.BACK) {
      this.renderEngineComponent.goBack();
      return;
    }
    if (actionData.navigationType === NavigationTypeEnum.ROUTER) {
      const url: UrlParser = new UrlParser(actionData?.params?.url);
      const requestPath: string = url.getPathParams();
      this.renderEngineComponent.navigateTo([requestPath], {
        queryParams: actionData?.params?.queryParams,
      });
      return;
    } else {
      const parts = actionData?.params?.url.split('/');
      let extractedPart: string = '';
      for (let i = 3; i < parts.length; i++) {
        extractedPart += `${parts[i]}${i === parts.length - 1 ? '' : '/'}`;
      }
      const path = this.renderEngineComponent.router.serializeUrl(
        this.renderEngineComponent.router.createUrlTree([extractedPart])
      );
      const formattedAction: ActionRequestDto = new ActionRequestDto();
      formattedAction.action = actionData?.type;

      const payload = { ...actionData?.params, url: path };
      formattedAction.payload = new ActionPayloadDto(payload);
      requestData.updatedAction = { ...formattedAction };

      window.open(
        requestData.updatedAction?.payload?.url ?? '/',
        requestData.updatedAction?.payload?.navigationOption,
      );

      return;
    }
  }
}
